const CURRENCY_SYMBOL = process.env.REACT_APP_CURRENCY_SYMBOL ?? "€";

export { CURRENCY_SYMBOL };
